import type { IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
// TODO: migrate to @sunwebgroup/uds-ui when available
import { useBreakpoints } from '@sunwebgroup/ui-components/uds'
import styles from './Category.module.css'

interface CategoryProps {
  icon: IconGlyph
  score?: number
  label: string
}

export function Category({ icon, score, label }: CategoryProps) {
  const { isDesktop } = useBreakpoints()

  return (
    <div className={styles.wrapper}>
      <Icon glyph={icon} size={isDesktop ? 16 : 32} />
      <div className={styles.scoreLabel}>
        <Typography variant="body-m-regular-tight">{label}</Typography>
        <Typography variant="body-m-bold-snug">{score?.toFixed(1)}</Typography>
      </div>
    </div>
  )
}
